<template>
  <div>
    <div v-if="searchStartedAt" class="small text-muted px-3 pt-3">
      بدء البحث عن سائق: {{ formatDate(searchStartedAt) }}
    </div>
    <div
      class="d-flex justify-content-between align-items-center px-3 pt-2"
    >
      <span class="small text-muted">
        آخر {{ candidates.length }} مرشحين للطلب. لا يُعتبر المرشح تعيينًا
        نهائيًا إلا عند حالة «قبل الطلب».
      </span>
      <v-btn small outlined color="#783D73" @click="openAll">
        عرض الكل
      </v-btn>
    </div>

    <v-data-table
      class="modern-data-table"
      :headers="headers"
      :items="candidates"
      item-key="id"
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:no-data>
        <div class="p-4 text-center text-muted">
          {{ $t("table.noData") }}
        </div>
      </template>

      <template v-slot:[`item.driver`]="{ item }">
        {{ driverName(item) }}
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <span
          class="badge px-3 py-1 font-weight-bold"
          :class="statusMeta(item.status).class"
          >{{ statusMeta(item.status).text }}</span
        >
      </template>

      <template v-slot:[`item.source`]="{ item }">
        {{ sourceText(item.source) }}
      </template>

      <template v-slot:[`item.offered_at`]="{ item }">
        {{ formatDate(item.offered_at) }}
      </template>
      <template v-slot:[`item.expires_at`]="{ item }">
        {{ formatDate(item.expires_at) }}
      </template>
      <template v-slot:[`item.accepted_at`]="{ item }">
        {{ formatDate(item.accepted_at) }}
      </template>
      <template v-slot:[`item.resolved_at`]="{ item }">
        {{ formatDate(item.resolved_at) }}
      </template>

    </v-data-table>

    <!-- All order candidates -->
    <v-dialog v-model="allDialog" max-width="1100px">
      <v-card>
        <v-card-title class="d-flex justify-content-between">
          <span>كل المرشحين للطلب #{{ orderId }}</span>
          <v-btn icon @click="allDialog = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            class="modern-data-table"
            :headers="headers"
            :items="allRows"
            :loading="allLoading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>
            <template v-slot:[`item.driver`]="{ item }">
              {{ driverName(item) }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                class="badge px-3 py-1 font-weight-bold"
                :class="statusMeta(item.status).class"
                >{{ statusMeta(item.status).text }}</span
              >
            </template>
            <template v-slot:[`item.source`]="{ item }">
              {{ sourceText(item.source) }}
            </template>
            <template
              v-for="key in dateColumns"
              v-slot:[`item.${key}`]="{ item }"
            >
              {{ formatDate(item[key]) }}
            </template>
          </v-data-table>

          <v-pagination
            v-if="allLastPage > 1"
            v-model.number="allPage"
            :length="allLastPage"
            :total-visible="5"
            class="mt-3"
            @input="loadAll"
          ></v-pagination>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  candidateStatusMeta,
  candidateSourceText,
  formatCandidateDate,
  candidateDriverName,
} from "@/helpers/candidates";

export default {
  name: "OrderCandidates",

  props: {
    candidates: { type: Array, default: () => [] },
    searchStartedAt: { type: String, default: null },
    orderId: { type: [Number, String], required: true },
    orderType: { type: String, default: "delivery" },
  },

  data() {
    return {
      dateColumns: ["offered_at", "expires_at", "accepted_at", "resolved_at"],
      allDialog: false,
      allRows: [],
      allPage: 1,
      allLastPage: 1,
      allLoading: false,
    };
  },

  computed: {
    headers() {
      const h = (text, value) => ({
        text,
        value,
        align: "center",
        sortable: false,
      });
      return [
        h("السائق", "driver"),
        h("المصدر", "source"),
        h("الحالة", "status"),
        h("الجولة", "round"),
        h("الترتيب", "sequence"),
        h("وقت العرض", "offered_at"),
        h("وقت الانتهاء", "expires_at"),
        h("وقت القبول", "accepted_at"),
        h("وقت الحسم", "resolved_at"),
      ];
    },
  },

  methods: {
    statusMeta: candidateStatusMeta,
    sourceText: candidateSourceText,
    formatDate: formatCandidateDate,
    driverName: candidateDriverName,

    openAll() {
      this.allPage = 1;
      this.allRows = [];
      this.allDialog = true;
      this.loadAll();
    },

    loadAll() {
      this.allLoading = true;
      this.$axios
        .get(`order/${this.orderId}/candidates`, {
          params: {
            order_type: this.orderType,
            page: this.allPage,
            per_page: 10,
          },
        })
        .then((res) => {
          this.allRows = res.data.data || [];
          this.allLastPage =
            (res.data.meta && res.data.meta.last_page) || 1;
        })
        .catch(() => {
          this.allRows = [];
        })
        .finally(() => {
          this.allLoading = false;
        });
    },
  },
};
</script>
